import lightGrayMediumDensityTheme from '@weave-design/theme-data/build/esm/lightGrayMediumDensityTheme';
import lightGrayHighDensityTheme from '@weave-design/theme-data/build/esm/lightGrayHighDensityTheme';
import darkBlueHighDensityTheme from '@weave-design/theme-data/build/esm/darkBlueHighDensityTheme';
import darkBlueMediumDensityTheme from '@weave-design/theme-data/build/esm/darkBlueMediumDensityTheme';
export var WeaveTheme;
(function (WeaveTheme) {
    WeaveTheme["Light"] = "HIG Light Theme";
    WeaveTheme["LightHighDensity"] = "HIG Light Theme (High Density)";
    WeaveTheme["Dark"] = "HIG Dark Theme";
    WeaveTheme["DarkHighDensity"] = "HIG Dark Theme (High Density)";
})(WeaveTheme || (WeaveTheme = {}));
export const weaveThemes = {
    'HIG Light Theme': lightGrayMediumDensityTheme,
    'HIG Light Theme (High Density)': lightGrayHighDensityTheme,
    'HIG Dark Theme': darkBlueMediumDensityTheme,
    'HIG Dark Theme (High Density)': darkBlueHighDensityTheme,
};
export const weaveLightThemes = {
    'HIG Light Theme': lightGrayMediumDensityTheme,
    'HIG Light Theme (High Density)': lightGrayHighDensityTheme,
};
export const weaveDarkThemes = {
    'HIG Dark Theme': darkBlueMediumDensityTheme,
    'HIG Dark Theme (High Density)': darkBlueHighDensityTheme,
};
